import { ReactNode } from 'react';
import { ToastType } from '@headless-workspace/glow-ds';
import { Toast, useToastActionsContext } from '../providers';

export type UseToastsReturnType = {
    notifyError: (label: ReactNode, options?: Toast['options']) => void;
    notifySuccess: (label: ReactNode, options?: Toast['options']) => void;
    notifyInfo: (label: ReactNode, options?: Toast['options']) => void;
    closeToast: (id: string) => void;
};

export const useToasts = (): UseToastsReturnType => {
    const { showToast, closeToast } = useToastActionsContext();

    return {
        notifyError(label: ReactNode, options?: Toast['options']) {
            return showToast({ label, type: ToastType.Error, options });
        },
        notifySuccess(label: ReactNode, options?: Toast['options']) {
            return showToast({ label, type: ToastType.Success, options });
        },
        notifyInfo(label: ReactNode, options?: Toast['options']) {
            return showToast({ label, type: ToastType.Info, options });
        },
        closeToast,
    };
};
